import EasyWins from './EasyWinsContainer';

export default EasyWins;
